import React, { Component } from 'react'
import Link from 'gatsby-link'
import { Player, BigPlayButton, ControlBar, Shortcut } from 'video-react'
import AttnLogo from '../components/attn-logo'
import Carousel from '../components/carousel'
import Footer from '../components/footer-new'

const media = [
  {
    id: 'first',
    type: 'video',
    image: '/img/rollupyoursleeves/carousel01.png',
    video: '/video/rollupyoursleeves/carousel01.mp4'
  },
  {
    id: 'second',
    type: 'video',
    image: '/img/rollupyoursleeves/carousel02.png',
    video: '/video/rollupyoursleeves/carousel02.mp4'
  }
]

const sizzleMedia = {
  image: '/img/rollupyoursleeves/NBC_RollUpYourSleeve_Promos_Announcement-still.png',
  video: '/video/rollupyoursleeves/NBC_RollUpYourSleeve_Promos_Announcement.mp4'
}

class VaccineSpecialPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isMobile: false,
      playing: false
    }

    this.playShowVideo = this.playShowVideo.bind(this)
    this.stopShowVideo = this.stopShowVideo.bind(this)
    this.handleShowPlayerState = this.handleShowPlayerState.bind(this)
  }

  componentDidMount () {
    const isMobile = window.innerWidth < 1024

    this.setState({
      isMobile
    })

    if (this.refs.showPlayer) {
      this.refs.showPlayer.subscribeToStateChange(this.handleShowPlayerState)
    }
  }

  handleShowPlayerState ({ ended }) {
    if (ended) {
      this.stopShowVideo()
    }
  }

  playShowVideo () {
    const { showVideo, showPlayer } = this.refs

    showVideo.scrollIntoView()
    this.setState({
      playing: true
    }, () => {
      showPlayer.play()
    })
  }

  stopShowVideo () {
    const { showPlayer } = this.refs
    showPlayer.pause()
    showPlayer.load()

    this.setState({
      playing: false
    })
  }

  render () {
    const { playing } = this.state

    return (
      <div className='show vaccine-special'>
        <header className='show-header'>
          <Link to='/'>
            <AttnLogo classes='logo' theme='dark' />
          </Link>
          <a
            className='client-logo'
            href=''
            target='_blank'
            rel='noreferrer noopener'
          >
            {/* <img src='' alt='Vaccine special' /> */}
          </a>
        </header>
        <div className='show-body'>
          <img className='show-body__image' src='/img/rollupyoursleeves/logo_wall.jpg' />
          <div className='show-body__video one-by-one' ref='showVideo'>
            <Player
              className='video'
              ref='showPlayer'
              aspectRatio='16:9'
              autoPlay={false}
              loop={false}
              muted={false}
              playsInline
              poster={sizzleMedia.image}
              preload='none'
              src={sizzleMedia.video}
            >
              <BigPlayButton disabled />
              <ControlBar disabled={!playing} />
              <Shortcut disabled={!playing} />
            </Player>
            {playing
              ? <div className='stop-button' onClick={this.stopShowVideo} />
              : <div className='play-button' onClick={this.playShowVideo} />
            }
          </div>
          <div className='show-body__cta-button'>
            <a
              href='https://madetosave.org'
              target='_blank'
              rel='noreferrer noopener'
              className='btn btn--primary-outline btn--icon-right'
            >
              Made to save
              <span><i className='fas fa-long-arrow-alt-right' /></span>
            </a>
          </div>
          <div className='show-body__post'>
            <p>
              Tune in on Sunday, April 18 at 7 p.m. ET/PT on NBC for Roll Up
              Your Sleeves Presented by Walgreens. This special night of
              entertainment event will educate viewers, raise awareness, and
              dispel concerns surrounding the COVID-19 vaccines, all with the
              goal of encouraging vaccinations to finally put an end to the
              pandemic.
            </p>
            <p>
              Hosted by Russell Wilson and Ciara, Roll Up Your Sleeves Presented
              by Walgreens will feature the biggest names in entertainment,
              including comedy from Billy Crystal and Wanda Sykes, appearances
              by Sterling K. Brown, Lana Condor, Eric Dane, Ryan Eggold,
              Jennifer Hudson, Dale Jarrett, Dr. Ken Jeong, Joe Jonas, Eva
              Longoria, Demi Lovato, Joel McHale, Kumail Nanjiani, Ellen Pompeo,
              Jane Seymour and many more! Plus, tune in to celebrate frontline
              heroes and witness heartwarming reunions of everyday people.
            </p>
            <p>
              Starting April 19, COVID-19 vaccines will be available to all
              American adults, to make a plan to ROLL UP YOUR SLEEVES!
            </p>
          </div>
          {media && media.length > 0
            ? <Carousel media={media} interval={15000} />
            : null
          }
        </div>
        <Footer theme='dark' />
      </div>
    )
  }
}

export default VaccineSpecialPage



// WEBPACK FOOTER //
// ./src/pages/rollupyoursleeves.js